{
  "app_notification_caption": "Счётчик непрочитанных появится в разделе 'Новости и обновления'",
  "attachment_remove": "Удалить файл",
  "attachment_upload_error": "Не удалось загрузить файл. Удалите его и попробуйте снова.",
  "attachments": "Вложения",
  "attachments_caption": "Добавьте один или несколько файлов к публикации",
  "blog": "Блог",
  "body_file_unavailable": "Не удалось открыть файл {name}",
  "bring_your_team_updates": "Соберите обновления вашей команды в одном месте: начните с канала для всех, а затем добавьте отдельные для конкретных тем",
  "channel_is_ready": "Этот канал готов — просто добавьте свою первую публикацию",
  "check_who_mentioned": "Посмотрите, кто вас упомянул, и ответьте при необходимости",
  "choose_bg_color": "Выберите цвет фона",
  "choose_channels": "Выберите ленты",
  "comments_disabled": "Комментарии к публикации отключены автором",
  "comments_disabled_switch": "Отключить комментарии к публикации",
  "configure_my_feed": "Настроить подписки",
  "create_channel": "Создать новую ленту",
  "create_first_channel": "Создайте свой первый канал",
  "create_yours_feed_caption": "Нажмите «Подписаться» на любой канал, который вам нравится, и он начнёт отображаться в вашей ленте — всё просто",
  "create_yours_feed_title": "Создайте ленту, которая будет вашей",
  "creating_post": "Создать новую публикацию",
  "delete_channel_question": "Вы хотите удалить эту ленту?",
  "delete_post_question": "Вы хотите удалить эту публикацию?",
  "edit_channel": "Редактировать ленту",
  "editing_post": "Редактирование публикации",
  "enter_content": "Введите содержимое публикации…",
  "enter_post_content": "Напишите текст публикации...",
  "error_need_one_feed_for_publishing": "Нужно выбрать хотя бы 1 ленту для публикации",
  "feed_name": "Название ленты",
  "for_preview": "Для предварительного просмотра новости на главном экране",
  "got_it": "Понятно",
  "hero_image": "Главное изображение",
  "manage_channels": "Управление лентами новостей",
  "manage_channels_description": "Создавайте, обновляйте или удаляйте ленты",
  "manage_comments": "Удаление комментариев",
  "manage_comments_description": "Проверяйте и удаляйте комментарии к постам",
  "manage_posts": "Управление публикациями",
  "manage_posts_description": "Редактируйте или удаляйте публикации",
  "mandatory_channel_caption": "Новости, которые стоит знать",
  "more_news": "Все новости",
  "my_feed": "Подписки",
  "new_feed": "Создать канал",
  "new_post": "Создать пост",
  "news": "Новости",
  "news_and_updates": "Лента",
  "no_posts": "Публикаций пока нет",
  "nothing_here": "Здесь пока ничего нет",
  "nothing_here_caption": "Ваша лента начнёт заполняться, как только каналы начнут публиковать обновления",
  "notification_settings_blog_caption": "Когда создают публикации или упоминают вас",
  "notify_subscribers_in": "Уведомить подписчиков в",
  "pdf_too_large": "PDF больше {size} МБ",
  "pdf_unsupported_format": "Загрузить можно только PDF",
  "post_body": "Контент публикации",
  "post_caption": "Краткое описание",
  "post_title": "Заголовок публикации",
  "post_without_image": "Опубликовать без иллюстрации",
  "posts": "Публикации",
  "preview_post": "Предпросмотр публикации",
  "publish": "Опубликовать",
  "publish_to": "Кто может публиковать ",
  "publish_to_caption": "Определите, кто сможет публиковать и редактировать новости в этой ленте. Редакторы автоматически видят новости.",
  "reactions_disabled": "Реакции к публикации отключены автором",
  "reactions_disabled_switch": "Отключить реакции к публикации",
  "read_more": "Читать полностью",
  "schedule": "Запланировать",
  "schedule_title": "Запланированная публикация. Будет опубликовано {time}",
  "scheduled_post": "Запланированная публикация",
  "slack_channel": "Канал в Slack",
  "subscribe": "Подписаться",
  "subscribe_all_employees": "Подписать всех сотрудников",
  "subscribe_all_employees_caption": "Это общий канал для всей компании: он виден всем, и подписка оформляется по умолчанию",
  "subscribed": "Вы подписаны",
  "video_too_large": "Видео больше {size} МБ",
  "video_too_large_hint": "Загрузите его на YouTube или Vimeo и вставьте ссылку",
  "video_unsupported_format": "Загрузить можно только видео MP4 и WebM",
  "view_mentions": "Посмотреть",
  "viewers": "Просмотревшие",
  "visible_to": "Кому видна",
  "visible_to_caption": "Определите, кто сможет видеть новости в этой ленте. Редакторы видят их автоматически.",
  "you_have_mentions": "У вас {count_mentions} в новостях",
  "~": ""
}
